import { useQuery } from '@tanstack/react-query';
import { fetchNonLCCApproversList } from '../../data-provider/select-options/non-lcc-approvers';
import type { ShipmentNonLCCApproversRequestParams } from '../../data-provider/select-options/non-lcc-approvers/api';

export const useGetNonLCCApprovers = (params: ShipmentNonLCCApproversRequestParams) => {
  return useQuery({
    queryKey: ['shipment-non-lcc-approvers-list', params?.customerKey],
    queryFn: () => fetchNonLCCApproversList(params),
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled: Boolean(params?.customerKey),
  });
};
